// guest.js

export default function guest({ next }) {
  if (localStorage.getItem('jwt-token')) {
    return next('/dashboard');
  }else{
    return next();
  }
}